/**
 * service: Resgate XML — Dashboard
 * Padrão interceptor: RestDashResgatePost(config) registrado em services/index.js.
 * config.data = JSON.stringify({ dest: 'nomeDaAcao', dataPost: [...] })
 */
import $ from 'jquery';
import { ENDERECO_API } from '../../config/constant';
import { decode as base64_decode, encode as base64_encode } from 'base-64';

const CTRL = `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`;
const MODULO = base64_encode('resgateXML');

const _creds = () => {
  const storage = JSON.parse(base64_decode(sessionStorage.getItem('ddesp')));
  return { emp: storage[0], uid: storage[3], token: storage[14] };
};

const _dd = (emp, uid, dataPost = []) =>
  base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))]));

const _decode = (raw) => {
  if (raw == null) return null;
  if (typeof raw === 'object') return raw;
  let s = String(raw).trim();
  // O controller retorna json_encode(base64_encode(...)) → resposta raw tem aspas JSON em volta
  if ((s.startsWith('"') && s.endsWith('"')) || (s.startsWith("'") && s.endsWith("'"))) {
    try { s = JSON.parse(s); } catch { s = s.slice(1, -1); }
  }
  try { return JSON.parse(base64_decode(s)); } catch { /* */ }
  try { return JSON.parse(s); } catch { /* */ }
  return s;
};

/**
 * POST genérico para ações do Dashboard Resgate XML.
 * Registrado em services/index.js como /api/dashboardResgate/.
 */
const RestDashResgatePost = (config) => {
  const Arr_    = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();
  const { dataPost = [] } = Arr_;

  return new Promise((resolve, reject) => {
    try {
      const { emp, uid, token } = _creds();
      $.ajax({
        url:      encodeURI(CTRL),
        type:     'POST',
        dataType: 'text',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: 'Bearer ' + token,
        },
        data: {
          pp: MODULO,
          ll: base64_encode(caminho),
          dd: _dd(emp, uid, dataPost),
        },
        success: (data) => resolve([200, _decode(data)]),
        error:   (xhr)  => reject([xhr?.status || 400, { message: 'Dados não localizados', status: xhr?.status }]),
      });
    } catch (err) {
      reject([500, { message: 'Server Error' }]);
    }
  });
};

export { RestDashResgatePost };
